import { InsightsListing } from "../components/InsightsListing";
import { loadInsights } from "../lib/insights";
import { seoMeta } from "../lib/seo";
import type { Route } from "./+types/insights";

export async function loader({ request }: Route.LoaderArgs) {
  return loadInsights(request);
}

export function meta({ loaderData, matches }: Route.MetaArgs) {
  return seoMeta({
    matches,
    title: "Insights — VEO Consultancy",
    description:
      "Research notes and practical guidance on offshore and local markets, retirement planning and long-term investing, written for Kenyan investors.",
    path: "/insights",
    // Only the first page is canonical to itself; later pages point back so
    // paginated duplicates do not compete with it in search results.
    noIndexFollow: (loaderData?.insights.meta.page ?? 1) > 1,
  });
}

export default function Insights({ loaderData }: Route.ComponentProps) {
  return <InsightsListing {...loaderData} />;
}
